<template>
  <div id="general-setting">
    <div class="tab-header">
      <v-row>
        <v-col sm="6">
          <label class="tab-title">{{ $t("GENERAL_SETTING") }}</label>
        </v-col>
        <v-col sm="6" class="text-right">
          <button class="btn btn-save" @click="save">{{ $t("SAVE") }}</button>
        </v-col>
      </v-row>
    </div>
    <div class="tab-content">
      <div class="email-setting">
        <v-subheader class="p-0">{{ $t("EMAIL_CONFIGURATION") }}</v-subheader>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("HOTEL_EMAIL") }} *</label>
            <input-text
              :model.sync="data.email"
              :error.sync="error.email.error"
              :errorMessage="error.email.message"
            />
          </div>
          <div>
            <label class="label-input">{{ $t("EMAIL_RECEIVE_BOOKING_ALERT_CC") }} *</label>
            <input-text
              :model.sync="data.notifyToEmail"
              :error.sync="error.notifyToEmail.error"
              :errorMessage="error.notifyToEmail.message"
            />
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">
              {{
              $t("EMAIL_CO_RECEIVE_BOOKING_ALERT_CC")
              }}
            </label>
            <input-text
              :model.sync="data.notifyCCEmail1"
              :error.sync="error.notifyCCEmail1.error"
              :errorMessage="error.notifyCCEmail1.message"
            />
          </div>
          <div>
            <label class="label-input">
              {{
              $t("EMAIL_RECEIVE_BOOKING_ALERT_BCC")
              }}
            </label>
            <input-text
              :model.sync="data.notifyBCCEmail"
              :error.sync="error.notifyBCCEmail.error"
              :errorMessage="error.notifyBCCEmail.message"
            />
          </div>
        </div>
      </div>

      <div class="email-setting">
        <v-subheader class="p-0">
          {{
          $t("DISPLAY_LANGUAGE_AND_WEEKEND")
          }}
        </v-subheader>
        <label class="label-input">{{ $t("DISPLAY_LANGUAGE") }} *</label>
        <v-layout wrap required>
          <v-checkbox
            class="mx-2"
            color="indigo darken-3"
            v-for="lang in language"
            :label="lang[systemLang]"
            :value="lang.lang"
            :key="lang.vi"
            v-model="displayLang"
          ></v-checkbox>
        </v-layout>
        <label class="label-input">{{ $t("WEEKEND") }} *</label>
        <v-layout wrap required>
          <v-checkbox
            class="mx-2"
            color="indigo darken-3"
            v-for="date in daysOfWeek"
            :label="date[systemLang]"
            :value="date.date"
            :key="date[systemLang]"
            v-model="weekend"
          ></v-checkbox>
        </v-layout>
      </div>

      <div class="email-setting">
        <v-subheader class="p-0">
          {{
          $t("CURRENCY_AND_TAXES_FEES")
          }}
        </v-subheader>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("CURRENCY_USED_IN_SYSTEM") }} *</label>
            <select-text
              :items="currency"
              :model.sync="data.usedCurrency"
              :error.sync="error.usedCurrency.error"
              :errorMessage="error.usedCurrency.message"
            />
          </div>
          <div>
            <label class="label-input">{{ $t("VAT_RATE_IS_APPLIES") }} *</label>
            <input-text
              :maxValue="100"
              :regex="REGEX_NUMBER"
              :model.sync="data.dataAddedTaxPercent"
              :error.sync="error.dataAddedTaxPercent.error"
              :errorMessage="error.dataAddedTaxPercent.message"
            />
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("SERVICE_TAX_RATE_APPLIES") }} *</label>
            <input-text
              :maxValue="100"
              :regex="REGEX_NUMBER"
              :model.sync="data.serviceTaxPercent"
              :error.sync="error.serviceTaxPercent.error"
              :errorMessage="error.serviceTaxPercent.message"
            />
          </div>
          <div>
            <v-checkbox
              :label="$t('PRICES_INCLUDE_TAXES_FEES')"
              color="indigo darken-3"
              v-model="data.includeTaxesInPrice"
            ></v-checkbox>
          </div>
        </div>
      </div>

      <div class="email-setting">
        <v-subheader class="p-0">
          {{
          $t("REGULATIONS_ON_CHILD_AGE_AND_ACCOMPANING_FEE")
          }}
        </v-subheader>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("YOUTH_IS_FREE_OF_CHARGE") }} *</label>
            <select-text
              :items="baged"
              :model.sync="data.baged"
              :error.sync="error.baged.error"
              :errorMessage="error.baged.message"
            />
          </div>
          <div>
            <label class="label-input">{{ $t("AGE_CHILD_EXTRA_CHARGE") }} *</label>
            <select-text
              :items="caged"
              :model.sync="data.caged"
              :error.sync="error.caged.error"
              :errorMessage="error.caged.message"
            />
          </div>
        </div>
      </div>

      <div class="email-setting no-border">
        <v-subheader class="p-0">{{ $t("OTHER_INFOMATION") }}</v-subheader>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("CHECKIN_TIME") }} *</label>
            <select-text
              :items="selectTime"
              :model.sync="data.checkInTime"
              :error.sync="error.checkInTime.error"
            />
          </div>
          <div>
            <label class="label-input">{{ $t("CHECKOUT_TIME") }} *</label>
            <select-text
              :items="selectTime"
              :model.sync="data.checkOutTime"
              :error.sync="error.checkOutTime.error"
            />
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("YEAR_BUILT") }}</label>
            <input-text
              :model.sync="data.yearOfBuild"
              :regex="REGEX_NUMBER"
              :notSmallThan="0"
              :error.sync="error.yearOfBuild.error"
            />
          </div>
          <div>
            <label class="label-input">
              {{
              $t("TOTAL_NUMBER_OF_FLOORS")
              }}
            </label>
            <input-text
              :regex="REGEX_NUMBER"
              :model.sync="data.numberOfFloors"
              :error.sync="error.numberOfFloors.error"
              :errorMessage="error.numberOfFloors.message"
            />
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("TOTAL_ROOM") }}</label>
            <input-text
              :regex="REGEX_NUMBER"
              :model.sync="data.numberOfRooms"
              :error.sync="error.numberOfRooms.error"
              :errorMessage="error.numberOfRooms.message"
            />
          </div>
          <div>
            <label class="label-input">{{ $t("DISTANCE_TO_AIRPORT") }} (km)</label>
            <input-text
              :regex="REGEX_DISTANCE"
              :model.sync="data.distanceToAirport"
              :error.sync="error.distanceToAirport.error"
              :errorMessage="error.distanceToAirport.message"
            />
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">
              {{
              $t("DISTANCE_TO_CITY_CENTER")
              }} (km)
            </label>
            <input-text
              :regex="REGEX_DISTANCE"
              :model.sync="data.distanceToCenter"
              :error.sync="error.distanceToCenter.error"
              :errorMessage="error.distanceToCenter.message"
            />
          </div>
          <div>
            <label class="label-input">{{ $t("TIME_TO_AIRPORT") }}</label>
            <input-text
              :regex="REGEX_DISTANCE"
              :model.sync="data.minutesToAirport"
              :error.sync="error.minutesToAirport.error"
              :errorMessage="error.minutesToAirport.message"
            />
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("VOLTAGE_USED") }}</label>
            <select-text :items="electronicVoltage" :model.sync="data.electronicVoltage" />
          </div>
          <div>
            <label class="label-input">{{ $t("ROOM_SERVICE") }}</label>
            <b-form-select
              :options="roomServices" 
              v-model="data.roomServices"
            />
          </div>
        </div>
        <div class="row-process">
          <div>
            <label class="label-input">{{ $t("TYPE_PROMOTION") }}</label>
             <b-form-select
              :options="typePromotion" 
              v-model="data.typePromotion"
            />
          </div>
        </div>

        <v-tabs v-model="tab" class="pl-0">
          <v-tab>{{ $t("VIETNAMESE") }}</v-tab>
          <v-tab>{{ $t("ENGLISH") }}</v-tab>
        </v-tabs>
        <v-row>
          <v-col sm="12">
            <label class="label-input">{{ $t("HOTEL_RULES") }}</label>
            <!-- <vue-editor v-model="data.i18ns.find(x => x.lang == lang).name"></vue-editor> -->
            <input-textarea
                    :rows="6"
                   :model.sync="data.i18ns.find(x => x.lang == lang).name"
                  />
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import { VueEditor } from "vue2-editor";
import {
  _validateFormI18n,
  _alert,
  _resetErrorState
} from "@/_helpers/function.js";
import {
  REGEX_PHONE,
  REGEX_ENTERPRISE_CODE,
  REGEX_NUMBER,
  REGEX_DISTANCE
} from "@/_helpers/constant.js";
import {
  DAYS_OF_WEEK,
  GE_LANGUAGE,
  GE_ROOM_SERVICES,
  CURRENCY,
  GE_ERROR,
  ELECT_VOLT
} from "@/_helpers/config.js";
import { service } from "@/_services/HotelSetting/general-setting.service.js";
import Textarea from "@/components/Utils/Textarea.vue";
export default {
  components: {
    "input-text": Input,
    "select-text": Select,
    VueEditor,
    "input-textarea": Textarea
  },
  created() {
    this.roomServices = GE_ROOM_SERVICES;
    this.initialize();
  },
  mounted() {
    document
      .querySelector(".v-tab.v-tab--active")
      .classList.remove("v-tab--active");
    document
      .querySelector(".v-tab[tabIndex='0']")
      .classList.add("v-tab--active");
  },
  data() {
    return {
      systemLang: this.$i18n.locale,
      data: [],
      error: Object.assign({}, GE_ERROR),
      // Config
      tab: null,
      lang: "vi",
      weekend: [],
      displayLang: [],
      selectTime: [],
      language: GE_LANGUAGE,
      baged: Array.from(new Array(17), (val, i) => i + 1),
      caged: Array.from(new Array(17), (val, i) => i + 1),
      electronicVoltage: ELECT_VOLT,
      daysOfWeek: DAYS_OF_WEEK,
      roomServices: GE_ROOM_SERVICES,
      currency: CURRENCY,
      typePromotion: [
        { value: 0, text: this.$t("SUM_PROMOTION") },
        { value: 1, text: this.$t("PRIORITY_PROMOTION") },
        { value: 2, text: this.$t("BEST_PROMOTION") }
      ],
      // End
    };
  },
  computed: {
    REGEX_ENTERPRISE_CODE() {
      return REGEX_ENTERPRISE_CODE;
    },
    REGEX_PHONE() {
      return REGEX_PHONE;
    },
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    REGEX_DISTANCE() {
      return REGEX_DISTANCE;
    },
    GE_ERROR() {
      return GE_ERROR;
    }
  },
  watch: {
    tab(value) {
      this.lang = value ? "en" : "vi";
    },
    lang(value) {
      this.editorData = this.data.i18ns.find(x => x.lang == value).name;
    },
    weekend(value) {
      this.data.weekend = value.join();
    },
    displayLang(value) {
      this.data.language = value.join();
    }
  },
  methods: {
    async initialize() {
      _resetErrorState(this.error);
      let x = 30; //minutes interval
      let tt = 0;

      for (let i = 0; tt < 24 * 60; i++) {
        let hh = Math.floor(tt / 60);
        let mm = tt % 60;
        this.selectTime[i] =
          ("0" + (hh % 24)).slice(-2) + ":" + ("0" + mm).slice(-2);
        tt = tt + x;
      }
      await service.get().then(res => {
        this.data = res.data;
        // console.log(this.data);
        // Default value if null
        if (
          !this.data.includeTaxesInPrice &&
          this.data.includeTaxesInPrice !== false
        ) {
          this.data.includeTaxesInPrice = true;
        }
        this.data.language = res.data.language || "en,vi";
        this.data.weekend = res.data.weekend || "SAT,SUN";
        this.data.checkInTime = this.data.checkInTime || "14:00";
        this.data.checkOutTime = this.data.checkOutTime || "12:00";
        // Display data
        this.displayLang = res.data.language.split(",");
        this.weekend = res.data.weekend.split(",");
        if (!this.data.i18ns || (this.data.i18ns && !this.data.i18ns.length)) {
          this.data.i18ns = [
            {
              lang: "vi",
              name: ""
            },
            {
              lang: "en",
              name: ""
            }
          ];
        }
        if (this.data.i18ns.find(x => x.lang == "vi").name == null) {
          this.data.i18ns.find(x => x.lang == "vi").name = "";
        }
        if (this.data.i18ns.find(x => x.lang == "en").name == null) {
          this.data.i18ns.find(x => x.lang == "en").name = "";
        }
      });
    },
    save() {
      let { isValid, error } = _validateFormI18n(this.data, this.error);
      this.error = error;
      if (!isValid) return false;
      let temp = Object.assign({}, this.data);
      temp.minutesToAirport = parseFloat(temp.minutesToAirport);
      service.update(temp).then(res => {
        _alert(res, this.$t(res.data));
      });
    }
  }
};
</script>
